import { render, staticRenderFns } from "./AuditoriaAcessoDetalhada.vue?vue&type=template&id=668bc7a4&scoped=true"
import script from "./AuditoriaAcessoDetalhada.vue?vue&type=script&lang=js"
export * from "./AuditoriaAcessoDetalhada.vue?vue&type=script&lang=js"
import style0 from "./AuditoriaAcessoDetalhada.vue?vue&type=style&index=0&id=668bc7a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668bc7a4",
  null
  
)

export default component.exports